import { useMutation } from '@tanstack/react-query';
import {
  exchangeWithdrawFormParams,
  type GetWithdrawDataRequest,
  type WithdrawParamsResponse,
} from '@/features/withdraw-bank-transfer';

export function useExchangeWithdrawFormParams() {
  const mutation = useMutation<
    WithdrawParamsResponse,
    Error,
    GetWithdrawDataRequest
  >({
    mutationFn: exchangeWithdrawFormParams,
    retry: 0,
  });

  return {
    exchangeWithdrawFormParams: mutation.mutate,
    exchangeWithdrawFormParamsAsync: mutation.mutateAsync,
    data: mutation.data,
    isParamsLoading: mutation.isPending,
    isParamsError: mutation.isError,
    paramsError: mutation.error,
    paramsReset: mutation.reset,
    exchangeWithdrawFormParamsMutation: mutation,
  };
}
